<template>
    <div class="productBox">
        <div v-for="item in list" :key="item.id" class="productItem">
            <div class="itemTitle">{{ item.title }}</div>
            <div class="listBox">
                <div @click="goDetail(item2)" v-for="item2 in item.product_list" :key="item2.id" class="listItem">
                    <img class="listImag" :src="item2.cover" alt="" />
                    <div class="footName">{{ item2.title }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        list: {
            type: Array,
            default: (() => []),
        },
    },
    data() {
        return {

        }
    },
    created() {

    },
    methods: {
        goDetail(item) {
            let lang = this.$i18n.locale == 'en' ? 'en' : 'cn'
            let path = ''
            if (item.type_id == 'bc7b8f90-c1f4-11ef-bcc2-cb1625e53d0d') {
                path = `/${lang}/systemsList`
                const route = this.$router.resolve({
                    path: `/${lang}/systemsList`,
                    query: {
                        product_id: item.product_id,
                        id: item.type_id,
                    }
                })
                window.open(route.href, '_blank')
            } else {
                path = `/${lang}/systemsDetail`
                const route = this.$router.resolve({
                    path: `/${lang}/systemsDetail`,
                    query: {
                        product_id: item.product_id,
                        id: item.type_id,
                    }
                })
                window.open(route.href, '_blank')
            }
            // this.$router.replace({
            //     path: `/${lang}/systemsDetail`,
            //     query: {
            //         product_id: item.product_id,
            //         id: item.type_id,
            //     }
            // })
            // this.$router.go(0)
        },
    },
}
</script>

<style lang="scss" scoped>
.productBox {
    width: 1200px;
    margin: auto;
    margin-top: 0px;
    margin-bottom: 116px;
}

.productItem {
    margin-top: 45px;

    .itemTitle {
        font-weight: 500;
        font-size: 40px;
        color: #000000;
        line-height: 42px;
    }

    .listBox {
        display: flex;
        flex-wrap: wrap;
        margin-top: 39px;
        gap: 20px;

        .listItem {
            width: 285px;
            margin-bottom: 48px;
            cursor: pointer;

            .listImag {
                width: 285px;
                height: 224px;
                display: block;
                object-fit: cover;
            }

            .footName {
                margin-top: 19px;
                font-weight: 500;
                font-size: 21px;
                line-height: 21px;
                color: #000000;
            }
        }
    }
}

@media screen and (max-width:1200px) {
    .productBox {
        width: 100%;
        margin: auto;
    }

    .productItem {
        margin-top: 20px;

        .itemTitle {
            font-weight: 500;
            font-size: 18px;
            color: #000000;
            line-height: 30px;
        }

        .listBox {
            display: flex;
            flex-wrap: wrap;
            margin-top: 39px;
            gap: 20px;

            .listItem {
                width: calc((100% - 20px) / 2);
                margin-bottom: 20px;

                .listImag {
                    width: 100%;
                    height: auto;
                    display: block;
                    object-fit: cover;
                }

                .footName {
                    margin-top: 12px;
                    font-weight: 500;
                    font-size: 14px;
                    line-height: 21px;
                    color: #000000;
                }
            }
        }
    }
}
</style>